import {UserTierTypes} from '@eCommerce/frontend-legacy-shared-library';
import {AxiosPromise, AxiosRequestConfig} from 'axios';
import {HostInfoTypes} from 'models/HostInfo';

import api, {AUTH_BASE_URL, MFA_BASE_URL, ResponseHeader} from 'api/api';
import {Channel} from 'api/auth';

const PROFILE_SERVICE_URL = 'ProfileService.svc/rest';

const AUTHENTICATION_SERVICE_URL = 'AuthenticationService.svc';

export enum EditProfileTransaction {
  create = 'create',
  update = 'update',
}

export interface GetSecurityProfileConfig extends AxiosRequestConfig {
  token: string;
}

export interface GetSecurityProfileResponse extends ResponseHeader {
  body?: {
    securityEmail?: string;
    mobilePhone?: string;
    tier?: UserTierTypes;
    restrictionStatus?: string[];
    host?: HostInfoTypes;
    channelPreference?: Channel;
  };
}

export interface EditSecurityProfileOpts {
  securityEmail?: {value: string; transaction: EditProfileTransaction};
  securityPhone?: {
    value: string;
    transaction: EditProfileTransaction;
    countryCode?: string;
  };
}
export interface EditSecurityProfileConfig
  extends EditSecurityProfileOpts,
    AxiosRequestConfig {
  token: string;
}

export interface EditSecurityProfileResponse extends ResponseHeader {}

export interface PasswordResetConfig {
  username: string;
}

export interface PasswordUpdateConfig {
  authToken: string;
  secCode: string;
  updatedPW: string;
  correlationId?: string;
}

const ProfileAPI = (config: AxiosRequestConfig): AxiosPromise => {
  config.baseURL = `${MFA_BASE_URL}/${PROFILE_SERVICE_URL}`;
  return api.request(config);
};

const AuthenticationServiceAPI = (config: AxiosRequestConfig) => {
  config.baseURL = `${AUTH_BASE_URL}/${AUTHENTICATION_SERVICE_URL}`;
  return api.request(config);
};

/**
 * POST request to retrieve user's email and mobile phone
 *
 * Requires a token
 *
 * @returns securityEmail and mobilePhone
 */
export const getSecurityProfile = async (data: GetSecurityProfileConfig) =>
  ProfileAPI({
    url: '/GetSecurityProfile',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });

/**
 * POST request to add/edit email and mobile phone
 * it is also suppose to send a verification link or OTP after add/edit
 */
export const editSecurityProfile = async (data: EditSecurityProfileConfig) =>
  ProfileAPI({
    url: '/EditSecurityProfile',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });

export const passwordReset = async (data: PasswordResetConfig) =>
  AuthenticationServiceAPI({
    url: '/PasswordReset',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });

export const passwordUpdate = async (data: PasswordUpdateConfig) =>
  AuthenticationServiceAPI({
    url: '/PasswordUpdate',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
